import { BackendApiClient } from "../api-client";
import { azdanceBookingAuthHeaders } from "@/lib/azdanceBookingSession";

export type BookingSummaryQuery =
  | { bookingCode: string; eventBookingId?: never; confirmationPaymentId?: string }
  | { eventBookingId: string; bookingCode?: never; confirmationPaymentId?: string };

/**
 * GET /azdance/booking/summary — по коду или id брони; сессия участника в заголовках.
 */
export async function fetchAztangofestBookingSummary(
  query: BookingSummaryQuery,
  language: string,
  accessToken?: string | null,
) {
  return BackendApiClient.AzdanceService.azdanceControllerGetEventBookingSummary(
    {
      language,
      bookingCode: "bookingCode" in query ? query.bookingCode : undefined,
      eventBookingId: "eventBookingId" in query ? query.eventBookingId : undefined,
      confirmationPaymentId: query.confirmationPaymentId?.trim() || undefined,
    },
    {
      headers: {
        ...azdanceBookingAuthHeaders(accessToken ?? undefined),
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    } as any,
  );
}
